import { Download } from '@mui/icons-material';
import {
  Button,
  DialogContent,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { DraggableDialog } from '~/components/Dialogs/components/DraggableDialog';
import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { CompanyFormsEntry } from '~/scenes/PeopleModule/components/Tabs/DocumentsTab/FormsTable/data';
import { getCompanyFormAttachmentUrl } from '~/utils/helper';

type PropsType = {
  employeeId: number;
  companyFormsEntries: CompanyFormsEntry[];
  isOpen: boolean;
  onClose: () => void;
};

export const CompanyFormsDialog = (props: PropsType) => {
  const { isOpen, onClose, employeeId, companyFormsEntries } = props;

  const { t } = useTranslation();

  return (
    <DraggableDialog
      open={isOpen}
      onClose={onClose}
      fullWidth={true}
      maxWidth={'lg'}
    >
      <SolaForceDialogTitle onClose={onClose}>
        {t('laCompanyForms')}
      </SolaForceDialogTitle>
      <Divider />
      <DialogContent sx={{ padding: 0 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('laFormName')}</TableCell>
              <TableCell>{t('laDescription')}</TableCell>
              <TableCell>{t('laExpirationDate')}</TableCell>
              <TableCell>{t('laDownload')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {companyFormsEntries.map((entry) => {
              return (
                <TableRow key={`entry_${entry.id}`}>
                  <TableCell>{entry.name}</TableCell>
                  <TableCell>{entry.description}</TableCell>
                  <TableCell>
                    {!!entry.expires ? moment(entry.expires).format('L') : ''}
                  </TableCell>
                  <TableCell size={'small'}>
                    <Button
                      href={getCompanyFormAttachmentUrl(
                        employeeId,
                        entry.attachmentId,
                      )}
                      target={'_blank'}
                      startIcon={<Download />}
                      sx={{ textTransform: 'none' }}
                    >
                      {entry.attachmentName}
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </DialogContent>
    </DraggableDialog>
  );
};
